<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('CHEERS')"
          :class="['nav-link link-nav-resident', step == 'CHEERS' && 'active']"
          id="nav-saude"
          data-toggle="tab"
          href="#saude"
          role="tab"
          aria-controls="saude"
          aria-selected="true"
          >SAÚDE</a
        >
        <a
          v-if="$store.state.online"
          @click="handleStep('GRAPHICS')"
          :class="[
            'nav-link link-nav-resident',
            step == 'GRAPHICS' && 'active',
          ]"
          id="nav-graficos"
          data-toggle="tab"
          href="#graficos"
          role="tab"
          aria-controls="graficos"
          aria-selected="true"
          >INFORMAÇÕES GRÁFICAS</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'CHEERS'"
        :class="['tab-pane', step == 'CHEERS' ? 'show active' : 'fade']"
        id="saude"
        role="tabpanel"
        aria-labelledby="nav-saude"
      >
        <Cheers />
      </div>
      <div
        v-if="step == 'GRAPHICS'"
        :class="['tab-pane', step == 'GRAPHICS' ? 'show active' : 'fade']"
        id="graficos"
        role="tabpanel"
        aria-labelledby="nav-graficos"
      >
        <Graphics />
      </div>
    </div>
  </div>
</template>

<script>
import Cheers from "./Cheers/Cheers";

import Graphics from "./Cheers/Graphics";

import routes from "../../routes";

import { userData } from "../../lib/functions";

export default {
  name: "MenuCheers",
  components: {
    Cheers,
    Graphics,
  },
  data() {
    return {
      accessed_offline: false,
      step: "CHEERS",
      rest_home_id: "",
      resident_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleStep(step) {
      let newNav;

      if (step == "CHEERS") {
        newNav = "cheers";
      }

      if (step == "GRAPHICS") {
        newNav = "graphics";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "cheers") {
          this.step = "CHEERS";
        }
        if (nav == "graphics") {
          this.step = "GRAPHICS";
        }
      }

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;
    },
  },
};
</script>
